import {map} from 'rxjs/operators';
import {riskLimitUtil} from '@px/helper/risk-limit';
import {curPositions$} from '../streams-contract/position';
import {riskLimitCache$, tradeLevelsCache$} from './config';
import {contract$} from './contract';
import {positionMerged$} from './position';

const positionLong$ = curPositions$.pipe(map((positions) => positions.find(({posSide}) => posSide === 'Long')));
const positionShort$ = curPositions$.pipe(map((positions) => positions.find(({posSide}) => posSide === 'Short')));

export const curRawRiskLimitOptions$ = riskLimitUtil.createRawRiskLimitOptions$(contract$, riskLimitCache$);

export const curRiskLimit$ = riskLimitUtil.createRealRiskLimit$(positionMerged$, curRawRiskLimitOptions$, tradeLevelsCache$);
export const curRiskLimitLong$ = riskLimitUtil.createRealRiskLimit$(positionLong$, curRawRiskLimitOptions$, tradeLevelsCache$);
export const curRiskLimitShort$ = riskLimitUtil.createRealRiskLimit$(positionShort$, curRawRiskLimitOptions$, tradeLevelsCache$);

export function genCurrentRiskLimit$(posSide: PosSide) {
  const map = {
    Merged: curRiskLimit$,
    Long: curRiskLimitLong$,
    Short: curRiskLimitShort$,
  };
  return map[posSide];
}
